/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_SelectionInputs */

const en_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Selection`)
};

const fr_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection claire`)
};

const de_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl löschen`)
};

const it_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella selezione`)
};

const ru_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить выбор`)
};

const es_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar selección`)
};

const zh_cn2_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除选择`)
};

const ja_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択を解除`)
};

const hi_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयन साफ़ करें`)
};

const pt_pt2_clear_selection = /** @type {(inputs: Clear_SelectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar seleção`)
};

/**
* | output |
* | --- |
* | "Clear Selection" |
*
* @param {Clear_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_selection = /** @type {((inputs?: Clear_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_clear_selection(inputs)
	if (locale === "de") return de_clear_selection(inputs)
	if (locale === "it") return it_clear_selection(inputs)
	if (locale === "ru") return ru_clear_selection(inputs)
	if (locale === "es") return es_clear_selection(inputs)
	if (locale === "zh-CN") return zh_cn2_clear_selection(inputs)
	if (locale === "ja") return ja_clear_selection(inputs)
	if (locale === "hi") return hi_clear_selection(inputs)
	if (locale === "pt-PT") return pt_pt2_clear_selection(inputs)
	return en_clear_selection(inputs)
});